import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { languageCodeZodSchema } from "@@/shared/translations/language-code";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";
import { userIdZodSchema } from "../user-id";

const setUserLanguageCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("SET_USER_LANGUAGE_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    userId: userIdZodSchema,
    language: languageCodeZodSchema.nullable(),
});

type SetUserLanguageCommand = z.infer<typeof setUserLanguageCommandZodObject>;

const setUserLanguageCommandFactoryParamsZodObject =
    setUserLanguageCommandZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });
type FactoryParams = z.infer<
    typeof setUserLanguageCommandFactoryParamsZodObject
>;

const setUserLanguageCommandFactory = (
    params: FactoryParams,
): SetUserLanguageCommand => {
    const command = {
        ...params,
        _id: generateId({ prefix: "SET_USER_LANGUAGE_COMMAND__" }),
        _type: "SET_USER_LANGUAGE_COMMAND" as const,
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export {
    setUserLanguageCommandFactory,
    setUserLanguageCommandFactoryParamsZodObject,
    setUserLanguageCommandZodObject,
};
export type {
    SetUserLanguageCommand,
    FactoryParams as SetUserLanguageCommandFactoryParams,
};
